export default "__VITE_ASSET__CQCns4EO__"